import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.addVirtualFileSystem(pdfFonts);

function splitArrayIntoGroups(array, groupSize) {
  const groups = [];
  for (let i = 0; i < array.length; i += groupSize) {
    groups.push(array.slice(i, i + groupSize));
  }
  return groups;
}

function normalizePdfImage(image) {
  if (!image || typeof image !== "string") {
    return null;
  }

  if (image.startsWith("data:image/")) {
    return image;
  }

  return `data:image/png;base64,${image}`;
}

function generate (data) {
  var doc = {
    pageSize: 'LETTER',
    content: [],
  };
  const sealImage = normalizePdfImage(data?.useData?.seal);
  const secondaryColor = "#263238"
  const branding = {
    columns: [],
    marginBottom: 0,
    marginTop:-15,
    columnGap: 10,
  };
  const logoWidth = 80;
  if (data.businessLogo) {
    // Add business logo
    branding.columns.push(
      {
        image: data.businessLogo,
        fit: [100, 100],
        alignment: 'left',
        width: logoWidth,
        margin: [0, 0, 0, 0]
      }
    );
  }

  // business name
  branding.columns.push({
    text: data.businessName,
    fontSize: 16,
    bold: true,
    alignment: 'center',
    width: '*',
    marginTop: 35,
  });

  if (data.businessLogo) {
    // Add business logo
    branding.columns.push(
      {
        text:'',
        width: logoWidth,
      }
    );
  }

  // add logo and title to doc
  doc.content.push(branding);

  // Document title
  doc.content.push({
    text: 'CERTIFICADO DE SALUD',
    fontSize: '12',
    bold: true,
    alignment: 'center',
    margin: [0, 5],
  });

  // Receiver
  doc.content.push({
    text: 'A quien interese',
    fontSize: '12',
    margin: [0, 5],
  });

  // Text 2
  doc.content.push({
    text: 'El ( la ) infrascrito (a) medico (a) veterinario (a) ha realizado el examen clinico al ejemplar:',
    fontSize: '12',
    margin: [0, 5],
  });

  // Patient info

  // name and species
  doc.content.push({
    columns: [
      {
        columns: [
          {
            text: 'Paciente:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.namepatient,
            width: '*',
          },
        ],
      },
      {
        columns: [
          {
            text: 'Especie:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.species,
            width: '*',
          },
        ],
      },
    ],
    margin: [0, 5, 0, 3],
  });
  
  // breed and gender
  doc.content.push({
    columns: [
      {
        columns: [
          {
            text: 'Raza:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.breed,
            width: '*',
          },
        ],
      },
      {
        columns: [
          {
            text: 'Sexo:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.gender,
            width: '*',
          },
        ],
      },
    ],
    margin: [0, 3],
  });
  
  // birthdate and color
  doc.content.push({
    columns: [
      {
        columns: [
          {
            text: 'Fecha de nacimiento:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.dateofbirth,
            width: '*',
          },
        ],
      },
      {
        columns: [
          {
            text: 'Color:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.color,
            width: '*',
          },
        ],
      },
    ],
    margin: [0, 3],
  });

  // microchip
  doc.content.push({
    columns: [
      {
        columns: [
          {
            text: 'Microchip:',
            color: secondaryColor,
            width: '*',
          },
          {
            text: data.patientInfo.microchip,
            width: '*',
          },
        ],
      },
      {
        text: '',
      }
    ],
    margin: [0, 3, 0, 5],
  });

  const clientName = data.patientInfo.customer.Is_a_Business 
    ? data.patientInfo.customer.BusinessName 
    : data.patientInfo.customer.FirstName + " " +  data.patientInfo.customer.LastName;

  // Owner
  doc.content.push({
    columns: [
      {
        columns: [
          {
            text: 'Propietario Sr./(a):',
            color: secondaryColor,
            width: 120,
          },
          {
            text: clientName,
            width: '*',
          },
        ],
      },
    ],
    margin: [0, 10, 0, 20],
  });

  // Statement
  doc.content.push({
    text: 'Hago constar que',
    fontSize: '12',
    bold: true,
    margin: [0, 5],
  });

  doc.content.push({
    text: 'Habiéndole encontrado libre de parásitos externos, enfermedades infecciosas y no infecciosas y en buen estado de salud y apto para realizar el viaje hacia su país de destino.',
    fontSize: '12',
    margin: [0, 5],
  });

  doc.content.push({
    text: `Además hacer constar haberle puesto y que están vigentes, las dosis propias de su edad, de las siguientes vacunas de la siguiente fecha (${data.dateReport}):`,
    fontSize: '12',
    margin: [0, 5, 0, 10],
  });

  if (data.vac && data.vac.length > 0) {
    const vaccines = data.vac.map(v => v.Medicine);
  
    const vacRows = splitArrayIntoGroups(vaccines, 3);

    for (const row of vacRows) {
      const docRow = {
        columns: [],
        fontSize: '12',
        margin: [0, 5],
      };

      for (const vaccine of row) {
        docRow.columns.push({
          text: vaccine,
          color: '#263238',
        });
      }

      doc.content.push(docRow);
    }
  }

  doc.content.push({
    text: `Por todo ello y para los usos que al interesado convengan extiendo la presente certificación.`,
    fontSize: '12',
    margin: [0, 30, 0, 5],
  });

  doc.content.push({
    text: data.branchinfo.BranchAddress + " , " + data.dateReport,
    fontSize: '12',
    margin: [0, 10],
  });

  if (sealImage) {
    // Add seal
    doc.content.push(
      {
        image: sealImage,
        width: 150,
        height: 150,
        alignment: 'center',
        margin: [0, 20, 0, 10]
      }
    );
  }

  doc.content.push({
    text: 'F. ___________________________________',
    fontSize: '12',
    alignment: 'center',
    margin: [0, 30, 0, 5],
  });

  doc.content.push({
    text: data.healthCertificate?.sign || '',
    fontSize: '12',
    alignment: 'center',
    margin: [0, 5],
  });

  pdfMake.createPdf(doc).open();
}

export default {
  generate,
}
